/*
 * @Author: 王琪瑞
 * @Date: 2021-04-20 16:07:53
 * @LastEditTime: 2021-04-29 15:53:41
 * @LastEditors: 王琪瑞
 */
import {
  reactive, ref, onMounted, watch, computed, SetupContext,
} from 'vue';
// import { PageI } from '@/interface/basicOperations';
import { message, Modal } from 'ant-design-vue';
import { definitions } from '@/types/api';
import axios from '@/axios/api';
import { cloneDeep } from 'lodash';
import { RuleObject } from 'ant-design-vue/es/form/interface';
import { Role } from '../../roleInfo/js/roleInfo';
import { RoleDataI } from '../../js/interface';

interface TalkType {
  text: string;
  value: number;
}

export interface DialogueI {
  list: definitions['CustomTalk'][];

  // 对话类型
  talkTypes: TalkType[];

  // 对话条件类型
  conditionTypes: TalkType[];
}

export class Dialogue implements DialogueI {
  list: definitions['CustomTalk'][] = []

  talkTypes: TalkType[] = [
    { text: '普通对话', value: 0 },
    { text: '任务对话', value: 1 },
    { text: '推演对话', value: 2 },
  ]

  conditionTypes: TalkType[] = [
    { text: '时间', value: 0 },
    { text: '指标', value: 1 },
    // { text: '完成指定功能', value: 2 },
    // { text: '完成指定对话', value: 3 },
    // { text: '完成指定选项', value: 4 },
  ]

  async query(caseId: string): Promise<definitions['CustomTalk'][]> {
    try {
      const { data } = (await axios.queryCustomTalkByCaseId(caseId)).data;

      this.list = data || [];

      return this.list;
    } catch (err) {
      throw new Error(err);
    }
  }
}

export default (context: SetupContext, caseId: string) => {
  // 对话
  const dialogueModule = reactive(new Dialogue());

  // 角色
  const roleModule = reactive(new Role(caseId));

  const roleMap = new Map();

  const roleNameFormat = (roleId: string, type: string) => {
    const roleItem: RoleDataI = roleMap.get(roleId);

    let roleStr = '';

    switch (type) {
      case 'img':
        roleStr = roleItem.roleImg || '';
        break;
      case 'name':
        roleStr = roleItem.roleName || '';
        break;
      default:
        break;
    }

    return roleStr;
  };

  // 对话编辑暂存
  const dialogueEditItem = reactive<{item: definitions['CustomTalk']}>({ item: {} });

  // 对话编辑暂存 form
  const dialogueEditForm = reactive<{item: definitions['CustomTalk']}>({ item: {} });

  const conditionTargetIds = ref([
    { targetId: '1', targetName: '受灾人数' },
    { targetId: '2', targetName: '群众满意度' },
    { targetId: '3', targetName: '政府公信力' },
    { targetId: '4', targetName: '信息掌握程度' },
    { targetId: '5', targetName: '资金' },
  ]);
  // 对话条件-指标-
  // 指标Id:分数-受灾人数-政府公信力-群众满意度
  const conditionTarget = reactive({
    targetType: '>',
    targetId: '1',
    targetScore: 0,
  });

  // 禁用相关
  const disableData = reactive<{
    add: boolean; // 添加对话禁用
    del: boolean; // 批量删除对话禁用
  }>({
    add: true,
    del: false,
  });

  // loading
  const loadings = reactive<{
    list: boolean; // 表格loading
  }>({
    list: false,
  });

  // 查询对话表格数据
  const queryDialogue = async (id = caseId) => {
    try {
      loadings.list = true;
      await dialogueModule.query(id);
    } catch (err) {
      throw new Error(err);
    } finally {
      loadings.list = false;
    }
  };

  // 是否显示编辑页
  const isShowEdit = ref<boolean>(false);

  // 推演选项表格列配置
  const deductionColumns = [
    {
      title: '选项名称',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: '操作',
      key: 'operation',
      width: '15%',
      slots: { customRender: 'operation' },
    },
  ];

  // 推演选项表格列配置 展开行
  const deductionExpandedColumns = [
    {
      title: '影响指标',
      dataIndex: 'norm',
      key: 'norm',
      slots: { customRender: 'norm' },
    },
    {
      title: '指标名称',
      dataIndex: 'normName',
      key: 'normName',
      slots: { customRender: 'normName' },
    },
    {
      title: '数值',
      dataIndex: 'score',
      key: 'score',
      slots: { customRender: 'score' },
    },
    {
      title: '操作',
      key: 'operation',
      width: '15%',
      slots: { customRender: 'operation' },
    },
  ];

  // 显示关键词
  const showKeyWords = computed(() => dialogueEditForm.item.talkType !== 0);

  // 显示推演选项
  const showDeduction = computed(() => dialogueEditForm.item.talkType === 2);

  const validateKeywordsArr = async (rule: RuleObject, value: string) => {
    if (!value || value.length === 0) {
      return Promise.reject(new Error('请输入关键词'));
    }
    return Promise.resolve();
  };

  // 表单验证
  const formRules = reactive({
    talkType: [{
      required: true, message: '请选择对话类型', trigger: 'change', type: 'number',
    }],
    roleId: [{ required: true, message: '请选择对话对象', trigger: 'change' }],
    talkName: [{
      required: true, message: '请输入对话名称', trigger: 'blur', whitespace: true,
    }],
    conditionType: [{
      required: true, message: '请选择对话条件', trigger: 'change', type: 'number',
    }],
    talkCondition: [{
      required: true, message: '请选择时间', trigger: 'change',
    }],
    content: [{
      required: true, message: '请输入对话内容', trigger: 'blur', whitespace: true,
    }],
    keywordsArr: [{ validator: validateKeywordsArr, trigger: 'change' }],
    delayedTime: [{
      required: true, message: '请选择延时触发时间', trigger: 'change', type: 'number',
    }],
  });

  // 对话信息表格列配置
  const columns = [
    {
      title: '对话对象',
      dataIndex: 'roleId',
      key: 'roleId',
      width: '15%',
      slots: { customRender: 'roleId' },
    },
    {
      title: '对话类型',
      dataIndex: 'talkType',
      key: 'talkType',
      width: '12%',
      slots: { customRender: 'talkType' },
    },
    {
      title: '对话名称',
      dataIndex: 'talkName',
      key: 'talkName',
      width: '15%',
    },
    {
      title: '对话内容',
      key: 'content',
      dataIndex: 'content',
      ellipsis: true,
    },
    {
      title: '操作',
      key: 'operation',
      width: '15%',
      slots: { customRender: 'operation' },
    },
  ];

  // 表格多选状态
  const chooseState = reactive<{selectedRowKeys: Array<string>}>({
    selectedRowKeys: [],
  });

  /**
   * 表格多选 change事件
   * @param keys 多选改变时的选择列表
   */
  const onSelectChange = (keys: Array<string>) => {
    chooseState.selectedRowKeys = keys;
  };

  /**
   * 选择全部
   */
  const selectAll = () => {
    if (chooseState.selectedRowKeys.length >= dialogueModule.list.length) {
      chooseState.selectedRowKeys = [];
    } else {
      chooseState.selectedRowKeys = dialogueModule.list.map((e) => e.id as string);
    }
  };

  const saveStep = () => {
    context.emit('saveStep');
  };

  /**
   * 选择删除对话
   */
  const delAll = () => {
    Modal.confirm({
      content: '是否确认删除选中的对话？',
      onOk: async () => {
        try {
          loadings.list = true;
          await axios.delCustomTalkByIds(chooseState.selectedRowKeys);
          message.success('删除成功');
          chooseState.selectedRowKeys = [];
          queryDialogue();
        } catch (err) {
          throw new Error(err);
        } finally {
          loadings.list = false;
        }
      },
    });
  };

  /**
   * 删除对话
   * @param id 对话id
   */
  const del = async (id: string) => {
    Modal.confirm({
      content: '是否确认删除该对话全部数据？',
      onOk: async () => {
        try {
          loadings.list = true;
          await axios.delCustomTalk(id);
          message.success('删除成功');
          const index = chooseState.selectedRowKeys.indexOf(id);
          if (index !== -1) {
            chooseState.selectedRowKeys.splice(index, 1);
          }
          await queryDialogue();
        } catch (err) {
          throw new Error(err);
        } finally {
          loadings.list = false;
        }
      },
    });
  };

  /**
   * 进入编辑页
   */
  const showEdit = (item: definitions['CustomTalk']) => {
    dialogueEditItem.item = item;

    dialogueEditForm.item = {};
    Object.assign(dialogueEditForm.item, cloneDeep(item));

    isShowEdit.value = true;
  };

  /**
   * 新增对话
   */
  const addDialogue = () => {
    dialogueEditItem.item = {
      caseId,
      conditionType: 0,
      content: '',
      keywords: '',
      keywordsArr: [],
      optionsList: [],
      roleId: '',
      talkCondition: '',
      talkName: '',
      talkType: 0,
      triggerCondition: 0,
      delayedTime: 0.5,
    };

    dialogueEditForm.item = {};
    Object.assign(dialogueEditForm.item, cloneDeep(dialogueEditItem.item));

    isShowEdit.value = true;
  };

  /**
   * 返回对话信息列表
   */
  const back = () => {
    isShowEdit.value = false;
  };
  const confirmBack = () => {
    Modal.confirm({
      content: '返回后未保存信息将会丢失，是否确认退出？',
      onOk: async () => {
        back();
      },
    });
  };

  /**
   * 保存对话
   */
  const dialogueEditSave = async () => {
    try {
      loadings.list = true;
      await axios.editCustomTalk(dialogueEditForm.item);
      Object.assign(dialogueEditItem.item, cloneDeep(dialogueEditForm.item));
      message.success('保存成功');
      back();
      queryDialogue();
    } catch (err) {
      throw new Error(err);
    } finally {
      loadings.list = false;
    }
  };

  const keyWordsChange = (value: string[]) => {
    if (value.length > 5) {
      value.splice(5);
      message.warning('每段对话最多添加五个关键词');
    } else if (value[value.length - 1] === '') {
      value.splice(value.length - 1, 1);
      message.warning('请输入关键词');
    }
  };

  watch(
    () => chooseState.selectedRowKeys,
    (keys) => {
      if (keys.length > 0) {
        disableData.del = false;
      } else {
        disableData.del = true;
      }
    },
    { deep: true, immediate: true },
  );

  watch(
    () => dialogueModule.list,
    (keys) => {
      if (keys.length < 100) {
        disableData.add = false;
      } else {
        disableData.add = true;
      }
    },
    { deep: true, immediate: true },
  );

  onMounted(async () => {
    await roleModule.query(caseId);

    roleModule.roleList.forEach((e) => {
      roleMap.set(e.id, e);
    });

    back();
    queryDialogue();
  });

  return {
    // Instance
    dialogueModule,
    roleModule,

    // Data
    roleMap,
    dialogueEditItem,
    dialogueEditForm,
    conditionTarget,
    conditionTargetIds,
    disableData,
    loadings,
    isShowEdit,
    columns,
    deductionColumns,
    deductionExpandedColumns,
    chooseState,
    formRules,
    showKeyWords,
    showDeduction,

    // Fn
    saveStep,
    roleNameFormat,
    queryDialogue,
    onSelectChange,
    selectAll,
    delAll,
    del,
    showEdit,
    addDialogue,
    confirmBack,
    dialogueEditSave,
    keyWordsChange,
  };
};
